import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/UserHome.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/progress",
    name: "Progress",
    // route level code-splitting
    // this generates a separate chunk (progress.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/UserProgress.vue"),
    meta: {
      title: "Progress",
    },
  },
  {
    path: "/content",
    name: "Content",
    // route level code-splitting
    // this generates a separate chunk (progress.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/UserSources.vue"),
    meta: {
      title: "Content",
    },
  },
  {
    path: "/upload",
    name: "Upload Content",
    component: () => import("../views/UserUploadContent.vue"),
    meta: {
      title: "Upload Content",
    },
  },
  {
    path: "/landing",
    name: "Wisery - Get smarter, easily retain & recall anything you read watch or listen to",
    // route level code-splitting
    // this generates a separate chunk (progress.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/UserLandingPage.vue"),
    meta: {
      title: "Wisery - Get smarter, easily retain & recall anything you read watch or listen to",
    },
  },
  {
    path: "/auth",
    name: "Auth",
    component: () => import("../views/UserAuth.vue"),
    meta: {
      title: "Login",
    },
  },
  {
    path: "/admin-review",
    name: "Admin Review",
    component: () => import("../views/AdminReview.vue"),
    meta: {
      title: "Admin Review",
      metaTags: [
        {
          name: "robots",
          content: "noindex, nofollow",
        },
      ],
    },
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: () => import("../views/AdminAnalytics.vue"),
    meta: {
      title: "Analytics",
      metaTags: [
        {
          name: "robots",
          content: "noindex, nofollow",
        },
      ],
    },
  },
  {
    path: "/extension",
    name: "Chrome Extension",
    component: () => import("../views/ChromeExtension.vue"),
    meta: {
      title: "Chrome Extension",
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/UserProfile.vue"),
    meta: {
      title: "Profile",
      metaTags: [
        {
          name: "robots",
          content: "noindex, nofollow",
        },
      ],
    },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: () => import("../views/UserSubscription.vue"),
    meta: {
      title: "Subscription",
      metaTags: [
        {
          name: "robots",
          content: "noindex, nofollow",
        },
      ],
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/PrivacyNotice.vue"),
    meta: {
      title: "Privacy Policy",
    },
  },
  {
    path: "/tos",
    name: "Terms of Service",
    component: () => import("../views/TermsOfService.vue"),
    meta: {
      title: "Terms of Service",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
